<template>
  <v-container>
    <v-row>
      <v-col lg="5" md="5" style="margin-left: 150px;
    height: 400px;
    width: 300px;">
        <v-img
            class="shrink mr-2"
            src="~@/assets/images/ARELOGO.svg"
            style="width: 30%; height: 100%;"
        >
        </v-img>
      </v-col>
      <v-col style="margin-top: 150px;margin-left: -75px">
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >

          <v-text-field

              v-model="email"
              :rules="emailRules"
              label="E-mail"
              required
          ></v-text-field>

          <v-text-field

              v-model="password"
              type="password"
              :rules="passwordRules"
              label="password"
              required
          ></v-text-field>
          <v-btn
              :disabled="!valid"
              color="success"
              class="mr-4"
              @click="validate"
          >
            Login
          </v-btn>

        </v-form>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import {login} from "@/shared/authService";
import state from "@/store/state";
import router from "@/router";

export default {
  name: "logIn",
  router,
  data: () => ({

    valid: true,
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    password: '',
    passwordRules: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 6) || 'Password must be at less 6 characters'
    ]
  }),
  methods: {
    validate() {

      if (this.$refs.form.validate()) {
        const data = {password: this.password, email: this.email};
        login(data).then(response => {
          localStorage.setItem('accessToken', response.data.token);
          state.accessToken = response.data.token;
          window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken')
          router.push('/products');
        },() => alert('password or email is invalid'));
      }
    },
  }
}
</script>

<style scoped>

</style>
